import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import type { RootState } from '@/redux/root-store';
import { analyticsStateSliceReducerKey } from './analytics-slice';

const analytics = (state: RootState) => state[analyticsStateSliceReducerKey];

const getSelectedOrganizationNames = createSelector(
  [analytics],
  s => s.selectedOrganizationNames ?? [],
);
export const useGetSelectedOrganizationNames = () => useSelector(getSelectedOrganizationNames);

const getAnalyticsDateRangeStrings = createSelector([analytics], s => ({
  start: s.dateRangeStart ?? null,
  end: s.dateRangeEnd ?? null,
}));
export const useGetAnalyticsDateRangeStrings = () => useSelector(getAnalyticsDateRangeStrings);
